import { useToastContext } from '@/context/ToastContext';
import styles from './Toast.module.css';

export function Toast() {
  const { toast } = useToastContext();

  const cls = [
    styles.toast,
    toast.open ? styles.show : '',
    toast.severity === 'success' ? styles.success : '',
    toast.severity === 'error' ? styles.error : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={cls} role="status" aria-live="polite">
      {toast.message}
    </div>
  );
}
